/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Detail_AllocationsInputs */

const vi_receipt_detail_allocations = /** @type {(inputs: Receipt_Detail_AllocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã phân bổ`)
};

/**

* @param {Receipt_Detail_AllocationsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_detail_allocations = /** @type {((inputs?: Receipt_Detail_AllocationsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Detail_AllocationsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_detail_allocations(inputs)
});